// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1AqDF","title":"Header_title__-j3-f","side":"Header_side__2ISQR"};